var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer",attrs:{"bg":""}},[_c('img',{attrs:{"src":"/images/footerv2.png","alt":""}})])
}]

export { render, staticRenderFns }